import { TYPE_LAYER_GEO_MARKETING_DEMO, TYPE_LAYER_GEO_MARKETING_ECO, TYPE_LAYER_GEO_MARKETING_CONCU } from '@/configuration/carteConf';

export const ASTEROP_BASE_URL = 'https://quadradiffusion.asterop.com/asterop/rest/quadradiffusion';
export const ASTEROP_API_KEY = 'WA-ZS8XT-163ED-9MYMH-CFDWM-NSHVG';
export const ASTEROP_SITES = '[{"zone":"{BF26A4B7-F9E3-4437-9CFA-C2ACDAB7B6FB}","site":"1"}]';
export const ASTEROP_LATITUDE_TAG = '<LATITUDE>';
export const ASTEROP_LONGITUDE_TAG = '<LONGITUDE>';
export const ASTEROP_ISOCHRONES_TAG = '<ISOCHRONES>';
export const ASTEROP_CONTEXT = `
{
  "dataCreations": {
    "t0": {
      "type": "asteropTableTypeEmbedded",
      "columns": [
        {
          "name": "bookmark",
          "type": "asteropDataKindInteger",
          "size": 4,
          "alias": "bookmark"
        },
        {
          "name": "geometry",
          "type": "asteropDataKindPoint",
          "alias": "geometry"
        }
      ],
      "primaryKey": [
        "bookmark"
      ],
      "values": [
        [
          1,
          {
            "type": "Point",
            "coordinates": [
              <LONGITUDE>,
              <LATITUDE>
            ]
          }
        ]
      ]
    }
  },
  "zones": [
    {
      "id": "{BF26A4B7-F9E3-4437-9CFA-C2ACDAB7B6FB}",
      "bounds": [
        <ISOCHRONES>
      ],
      "sitesTable": {
        "table": "dataCreations:t0",
        "codecolumn": "bookmark",
        "namecolumn": "bookmark"
      }
    }
  ]
}
`;

export const MAP_URL_BY_TYPE = {
};
MAP_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_DEMO] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{01195051-2126-4BAD-AF0E-9FA2D3F28345}';
MAP_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_ECO] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{EFAF2215-38BD-4641-9474-C19AF244D337}';
MAP_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_CONCU] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{D51F6251-333C-4E0F-984B-FD1C6628DEA2}';

export const DATA_URL_BY_TYPE = {
};
DATA_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_DEMO] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{2B709977-7DFB-4F2A-80F3-9C66CD7315D8}';
DATA_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_ECO] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{6984FAA3-CAF4-495C-9CF7-C1611F53D642}';
DATA_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_CONCU] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{D51F6251-333C-4E0F-984B-FD1C6628DEA2}';


const CHART_URL_BY_TYPE = {
};
CHART_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_DEMO] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{9E8DC4A5-40AC-49B1-8FDB-A80EB8632DD2}';
CHART_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_ECO] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{BA5941FB-DBB9-43E0-AB03-FB2B26F70676}';
CHART_URL_BY_TYPE[TYPE_LAYER_GEO_MARKETING_CONCU] = '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{9E8DC4A5-40AC-49B1-8FDB-A80EB8632DD2}';


export function getIsochroneWithZone(isochrone, noZone) {
  if (noZone) {
    return isochrone;
  }
  return [
    Math.floor(isochrone / 3),
    Math.floor(isochrone * 2 / 3),
    isochrone,
  ];
}

export function getQueryString(type, location, isochrone, noZone) {
  const isochrones = getIsochroneWithZone(isochrone, noZone);
  const context = ASTEROP_CONTEXT
    .replace(/$/mg, '')
    .replace(/\s/mg, '')
    .replace(ASTEROP_LATITUDE_TAG, location.lat)
    .replace(ASTEROP_LONGITUDE_TAG, location.lng)
    .replace(ASTEROP_ISOCHRONES_TAG, isochrones);
  const queryItems = {
    f: type,
    key: ASTEROP_API_KEY,
    sites: ASTEROP_SITES,
    context,
  };
  return queryItems;
}

export function getGeoJsonUrl(type, location, isochrone) {
  const queryItems = getQueryString('geojson', location, isochrone, true);
  const url = ASTEROP_BASE_URL +
    MAP_URL_BY_TYPE[type] + '/layers/0';
  return url + '?' + Object.keys(queryItems)
    .map(k => k + '=' + queryItems[k])
    .join('&');
}

export function getChartUrl(type, location, isochrone) {
  const queryItems = getQueryString('png24', location, isochrone, true);
  queryItems.width = 600;
  queryItems.height = 300;
  const url = ASTEROP_BASE_URL +
    CHART_URL_BY_TYPE[type];
  return url + '?' + Object.keys(queryItems)
    .map(k => k + '=' + queryItems[k])
    .join('&');
}

export function getOtherUrl() {
}



// WEBPACK FOOTER //
// ./src/services/asterop/getUrl.js